import { z } from 'zod';
export const BPR_PRICING_METHODS = ['rule', 'model', 'unpriced'];
export const bprPricingMethodSchema = z.enum(BPR_PRICING_METHODS);
export const bprFiredRuleSchema = z.object({
    ruleId: z.string(),
    hours: z.number(),
    reason: z.string().optional(),
});
export const bprLinePricingResultSchema = z.object({
    lineId: z.string(),
    recommendationUuid: z.string().uuid(),
    findingUuid: z.string().uuid().optional(),
    categoryKey: z.string(),
    issueKey: z.string(),
    patternKey: z.string().nullable().optional(),
    method: bprPricingMethodSchema,
    hours: z.number().nonnegative().nullable(),
    provisional: z.boolean().optional(),
    reason: z.string().optional(),
    assumptions: z.array(z.string()).default([]),
    confidence: z.number().min(0).max(1).optional(),
    drivers: z.record(z.any()).default({}),
    firedRules: z.array(bprFiredRuleSchema).default([]),
    evidenceRefs: z.array(z.string()).default([]),
});
export const bprEstimateOutputSummarySchema = z.object({
    totalHours: z.number(),
    isPartial: z.boolean(),
    methodCounts: z.object({
        rule: z.number().int().nonnegative(),
        model: z.number().int().nonnegative(),
        unpriced: z.number().int().nonnegative(),
    }),
    lines: z.array(bprLinePricingResultSchema),
    problemBatchId: z.string().optional(),
    solutionBatchId: z.string().optional(),
    pricingRunId: z.number().optional(),
});
export const bprUnmatchedPricingItemSchema = z.object({
    id: z.string(),
    categoryKey: z.string(),
    issueKey: z.string(),
    title: z.string(),
    rationale: z.string().optional(),
    declineReason: z.string().optional(),
    drivers: z.record(z.any()).default({}),
    evidenceQuotes: z
        .array(z.object({
        quote: z.string(),
        speaker: z.string().nullable().optional(),
    }))
        .default([]),
});
export const bprUnmatchedPricingResultItemSchema = z.object({
    id: z.string(),
    hours: z.number().nonnegative().nullable(),
    method: z.enum(['model', 'unpriced']),
    reason: z.string(),
    assumptions: z.array(z.string()).default([]),
    confidence: z.number().min(0).max(1).optional(),
    evidenceRefs: z.array(z.string()).default([]),
});
export const bprUnmatchedPricingOutputSchema = z.object({
    items: z.array(bprUnmatchedPricingResultItemSchema),
});
//# sourceMappingURL=bpr-pricing.js.map